import React from 'react';
import ShareSocialMediaPopUpContent from './ShareSocialMediaPopUpContent';
import PopUp from './PopUp';

const ShareSocialMediaPopUp = () => {
  return (
    <PopUp title="Udostępnij" popupName="share-social-popup">
      <ShareSocialMediaPopUpContent />
    </PopUp>
  );
};

export default ShareSocialMediaPopUp;
